import React from 'react';
import Navbar from '../components/Navbar';
import AboutHeader from '../components/AboutHeader';
import AboutSection from '../components/AboutSection';
import SupportBanner from '../components/SupportBanner';
import TransportForm from '../components/TransportForm';
import Footer from '../components/Footer';

function About() {
  return (
    <div>
      <Navbar />
      <AboutHeader />
      {/* Boşluk için ek div ve Tailwind sınıfı */}
      <div className="h-10 bg-[#D9D9D9]"></div> {/* Bu 40px'lik bir boşluk ekler */}
      <div className="bg-[#D9D9D9]">
        <AboutSection />
      </div>
      <SupportBanner />
      <TransportForm />
      <Footer />
    </div>
  );
}

export default About;
